import React, { useState } from 'react'
import building from '../../../../images/building.svg'
import location from '../../../../images/location.svg'
import clock from '../../../../images/clock.svg'
import bag from '../../../../images/bag.svg'
import bullet from '../../../../images/bullet.svg'
import { Container, Col, Row, Form, Button, Card} from 'react-bootstrap';
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';


const Menu = ({jobs}) => {
    const [selectedJob, setSelectedJob] = useState(jobs[0])
    const navigate = useNavigate();

  const handleReadMore = () => {
    navigate(`/read-more/${jobs.id}`);
  };

  return (
    <div>
      <Row className='d-none d-lg-flex m-5 p-3' style={{border:'2px solid #E2E8F0'}}>
        <Col className=''>
        {
          jobs.length < 1 && 
          <div className='no-find' style={{ background: '#CCCCDD'}}>We could not find your search results</div>
        }
        {
              jobs.map((jobs) => {
                const{id,image,role,company,location,amount,datePosted,workMode,jobType,aboutUs,qualifications,jobDescription,industries} = jobs;
              
                return(
                  <Card className={` ${selectedJob && selectedJob.id === id ? 'active-job ' : 'job-container'}`} 
                  key={id} onClick={() => setSelectedJob(jobs)}>
                      <div className='d-flex justify-content-between align-items-center'>
                      <h4>{role}, {industries}</h4>
                      <p className='date'>{datePosted}</p>
                      </div>
                      
                      <h5>{company} - {location}</h5>
                      <h6>{jobType}, &nbsp;{workMode}</h6>
                      <p>Salary Range: {amount}</p>
                      <Link className='text-center'>Read More ...</Link>
                  </Card>
                )
              })
            }
        </Col>
        <Col >
        {
          jobs.length < 1 && <div className='no-find' style={{ background: '#CCCCDD'}}>Try Again</div>
        } 
        { jobs.length > 0 && selectedJob && 
              <Card className='py-3 px-2 border-0' style={{background: '#CCCCDD'}}>
                <div className='d-flex gap-3 description-header'>
                  <img className='company-job-image' src={selectedJob.image}/>
                  <h1>{selectedJob.role}</h1>
                </div>
                <div className='d-flex justify-content-between mt-3'>
                  <div className='align-items-center gap-2'>
                    <p className='company-building'><img src={building}/>&nbsp;{selectedJob.company}</p>
                    <p className='company-building'><img src={location}/> {selectedJob.location}</p>
                  </div>
                  <div className='d-flex align-items-center justify-content-center text-center '>
                  <button className='company-apply-btn'>Apply Now</button>
                  </div>
                </div>
                <div className='apply-line'></div>
                <div className='about-us'>
                  <h4>About Us</h4>
                  <p>{selectedJob.aboutUs}</p>
                </div>
                <div className='apply-line'></div>
                <div className='job-details-section'>
                  <h4>Job Details</h4>
                  <div className=' d-xl-flex d-lg-block align-items-center justify-content-between selected-job-details-info'>
                  <div className='gap-2'>
                    <p className='job-type'><img src={bag} /> &nbsp; &nbsp;{selectedJob.jobType}, {selectedJob.workMode}</p>
                    <p className='job-type'><img src={clock}/> &nbsp;&nbsp;{selectedJob.datePosted}</p>
                  </div>
                  <h6>Salary Range: {selectedJob.amount}</h6>
                </div>
                </div>
                <div className='apply-line'></div>
                <Row className='gap-2'>
                <Col xl={5} md={12} className='qualifications-section'>
                  <h4>Qualifications</h4>
                  <div className='qualifications'>
                  {selectedJob.qualifications.map((qualification) => (
                    <div className='qualification'>
                      <img src={bullet}/>
                      <p>{qualification}</p>
                    </div>
                    ))} 
                  </div>

                </Col>
               
                <Col xl={6} md={12}  className='description-section'>
                  <h4>Job Description</h4>
                  <div className='descriptions'>
                  {selectedJob.jobDescription.map((description) => (
                    <div className='description-1' >
                      <img src={bullet}/>
                      <p>{description}</p>
                    </div>
                    ))} 
                  </div>

                </Col>
                </Row>
              </Card>
            } 
        </Col>
      </Row>

      <Row className='d-block d-lg-none my-5 mx-1 py-3 px-2' style={{border:'2px solid #E2E8F0'}}>
        <Col className=''>
        {
          jobs.length < 1 && 
          <div className='no-find' style={{ background: '#CCCCDD'}}>We could not find your search results.
          <br/> Try Again</div>
        }
        {
              jobs.map((jobs) => {
                const{id,image,role,company,location,amount,datePosted,workMode,jobType,aboutUs,qualifications,jobDescription,industries} = jobs;
              
                return(
                  <Card className={` ${selectedJob.id === id ? 'active-job ' : 'job-container'}`} 
                  key={id}>
                      <div className='d-block d-sm-flex justify-content-between align-items-center'>
                      <h4>{role}, {industries}</h4>
                      <p className='date'>{datePosted}</p>
                      </div>
                      
                      <h5>{company} - {location}</h5>
                      <h6>{jobType}, &nbsp;{workMode}</h6>
                      <p>Salary Range: {amount}</p>
                      <Link to={`/read-more/${id}`} className='text-center'>Read More ...</Link>
                  </Card>
                )
              })
            }
        </Col>
      </Row>
   
    </div>
  )
}

export default Menu
